<template></template>
<script>
export default {
    created() {
        if (this.$loadModule('treatments')) {
            this.$router.replace({ name: 'people.customer.treatment' });
        } else {
            this.$router.replace({ name: 'people.customer.general' });
        }
    }
}
</script>
